




























import { Component, Vue, Prop } from "vue-property-decorator";
import { Form as elForm } from "element-ui";
import axios, { resHandle } from "@/plugins/axios";
@Component({})
export default class FastLoginCmp extends Vue {
  private info: any = {
    手机号: "",
    验证码: ""
  };
  private rules: any = {
    手机号: [{ required: true, message: "手机号必须填写", trigger: "blur" }],
    验证码: [{ required: true, message: "验证码必须填写", trigger: "blur" }]
  };
  private codeState: "able" | "disabled" = "able";
  private codeCountdownTime: number = 60;
  /**
   * @description 倒计时
   */
  private countdownCodeWaitTime() {
    const interval = setInterval(() => {
      this.codeCountdownTime--;
      localStorage.setItem("loginCountDown", String(this.codeCountdownTime));
      if (this.codeCountdownTime === 0) {
        clearInterval(interval);
        this.codeCountdownTime = 60;
        localStorage.setItem("loginCountDown", "60");
        this.codeState = "able";
      }
    }, 1000);
  }
  /**
   * @description 获取验证码
   */
  private getPhoneCode() {
    (this.$refs.loginForm as elForm).validateField("手机号", (msg: any) => {
      if (!msg) {
        const params: any = {
          手机号: this.info["手机号"]
        };
        axios.post("api/user/phonecode", params).then(({ data }) => {
          resHandle(this, data).then(() => {
            this.codeState = "disabled";
            this.countdownCodeWaitTime();
          });
        });
      }
    });
  }
  /**
   * @description 登录
   */
  private login() {
    (this.$refs.loginForm as elForm).validate((isValid: boolean) => {
      if (isValid) {
        const params: any = {
          手机号: this.info["手机号"],
          验证码: this.info["验证码"]
        };
        this.$store
          .dispatch("login", params)
          .then(() => {
            this.$router.push("/main/szjx/szjc-folder");
          })
          .catch((error: string) => {
            console.log(error);
            this.$message.error(error);
          });
      }
    });
  }
  /**
   * @description 初始化
   */
  private beforeMount() {
    const n = localStorage.getItem("loginCountDown") || "60";
    this.codeCountdownTime = Number(n);
    if (this.codeCountdownTime !== 60) {
      this.codeState = "disabled";
      this.countdownCodeWaitTime();
    }
  }
}
